/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FcbDegreGridDto } from './FcbDegreGridDto';
import {
    FcbDegreGridDtoFromJSON,
    FcbDegreGridDtoFromJSONTyped,
    FcbDegreGridDtoToJSON,
} from './FcbDegreGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface FcbDegreGridDtoPaginatedResults
 */
export interface FcbDegreGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof FcbDegreGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<FcbDegreGridDto>}
     * @memberof FcbDegreGridDtoPaginatedResults
     */
    results?: Array<FcbDegreGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof FcbDegreGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the FcbDegreGridDtoPaginatedResults interface.
 */
export function instanceOfFcbDegreGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FcbDegreGridDtoPaginatedResultsFromJSON(json: any): FcbDegreGridDtoPaginatedResults {
    return FcbDegreGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function FcbDegreGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FcbDegreGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(FcbDegreGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function FcbDegreGridDtoPaginatedResultsToJSON(value?: FcbDegreGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(FcbDegreGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

